<ng-container *ngIf="skillsWithDeeplinks.length > 0">
  <h3 class="ss-subtitle">Targeted Practice</h3>
  <div class="container">
    <div class="header-container">
      <object type="image/svg+xml" role="presentation" alt="" class="freckle-logo" data="assets/logos/renaissance_freckle_logo.svg"></object>
      <div class="vertical-bar"></div>
      <div class="header-description">
        <div class="header-description-top">
          Targeted Practice Assignment
        </div>
        <div class="header-description-bottom">
          Assign skills for {{standard.standardName}} to some or all students
        </div>
      </div>
    </div>
    <div *ngFor="let skill of skillsWithDeeplinks; let isFirst = first; let isLast = last"
      class="skill-container" [ngClass]="{'first-skill': isFirst, 'last-skill': isLast}">
      <span class="skill-name" [innerHTML]="skill.skillName"></span>
      <a type="button" class="ren-btn ren-btn--secondary take-action"
        aria-label="Preview and Assign (opens in a new tab)"
        tabindex="0"
        (click)="navigateToFreckleSkill(skill)" (keydown.enter)="navigateToFreckleSkill(skill)">
        Preview and Assign
        <span class="glyph glyph-externallink margin-left-xsmall"></span>
      </a>
    </div>
  </div>
</ng-container>
